import { RvExtracts, RvSummary } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getRvExtracts = async () =>
  await client.get<ResponseSuccess<RvExtracts>>(`v1/variable-revenue/extracts`)

export const getRvSummary = async () =>
  await client.get<ResponseSuccess<RvSummary>>(`v1/variable-revenue/summary`)
